import { Toaster as ModuleToaster } from 'react-hot-toast'

export const Toaster = () => (
  <ModuleToaster
    gutter={8}
    position="top-right"
    toastOptions={{
      duration: 5000,
      style: {
        padding: '12px',
        color: 'var(--White20)',
        fontFamily: `'Source Sans Pro', sans-serif`,
        fontSize: '15px'
      },
      success: {
        style: {
          background: 'var(--SuccessBG)',
          border: 'solid 1px #59bf75'
        }
      },
      error: {
        style: {
          background: 'var(--ErrorBG)',
          border: 'solid 1px #d24c4c'
        }
      }
    }}
  />
)
